import { Component, Input, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-grid-svg-icons',
  templateUrl: './ag-grid-svg-icons.component.html',
  styleUrls: ['./ag-grid-svg-icons.component.scss']
})
export class AgGridSvgIconsComponent implements OnInit, ICellRendererAngularComp {

  requirementInfoDetailsIcon: boolean = false;
  public params!: any;
  public value!: string;
  public tooltipContent: string = '';

  constructor() { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value ?? '';
    this.requirementInfoDetailsIcon = !!params?.colDef?.cellRendererParams?.requirementInfoDetailsIcon;
    if (this.requirementInfoDetailsIcon) {
      const yearName = (params?.data?.dateCodeYearName ?? '').trim();
      const weekName = (params?.data?.dateCodeWeekName ?? '').trim();
      let dateCode = '';
      if (yearName) {
        dateCode = yearName;
        dateCode += weekName ? `${weekName}` : '+';
      }
      this.tooltipContent = `Date Code: ${dateCode}\n Testing: ${params?.data?.testingName ? params?.data?.testingName + '\n' : ''} ${params?.data?.requiredInspectionReport ? 'Inspection Report Required' + '\n' : ''} ${params?.data?.manufacturerCOC ? 'Manufacturer COC ' + '\n' : ''} ${params?.data?.companyCOC ? 'Company COC' + '\n' : ''} ${params?.data?.requiredImages ? 'Requires Images' : ''}`.trim();
      this.tooltipContent = this.tooltipContent || '';
    }
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false
  }

  ngOnInit(): void {
  }

  changeRoute(params) {
    this.onClick(params)
  }  
  onClick(params){
      const customEvent = new CustomEvent('textCellClick', {
        detail : { data: this.params },
      });
      document.dispatchEvent(customEvent);
  }

}
